<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>IncRNA测序</h1>-->
<!--          <h2 class="mt10">lncRNA sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>IncRNA测序</h1>
      <h2 class="mt10">IncRNA Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">长链非编码 RNA（Long non-coding RNA，lncRNA）一类长度大于 200 nt 且不编码蛋白质的 RNAs（不含 rRNA），广泛存在于各种生物体内。lncRNA高通量测序，对长链非编码 RNA、mRNA 、环状RNA等大RNA进行测序研究，从而快速全面准确地获得与特定生物学过程（例如发育、疾病等）所有大RNA转录本数据信息，可应用于细胞分化和发育的研究、调控机理的研究、疾病标志物的寻找、疾病的分子诊断、基因药物的研发等。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/inc_icon_1.png">
            <p>新lncRNA找寻与预测</p>
          </li>
          <li>
            <img src="@/assets/images/inc_icon_2.png">
            <p>疾病研究</p>
          </li>
          <li>
            <img src="@/assets/images/inc_icon_3.png">
            <p>调控网络研究</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/inc_icon_1.png">
            <p>新lncRNA找寻与预测</p>
          </li>
          <li>
            <img src="@/assets/images/inc_icon_2.png">
            <p>疾病研究</p>
          </li>
          <li>
            <img src="@/assets/images/inc_icon_3.png">
            <p>调控网络研究</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术参数</div>
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>HiSeq/Novaseq PE150 DNBSEQ T7 PE150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_5.png">
          <h4>项目周期</h4>
          <p>40个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>20 G</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>Q30 > 80%</p>
        </li>
      </ul>
      <div class="c-title">技术路线</div>
      <div class="tc con"><img src="@/assets/images/inc_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/inc_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/incRNA.vue